<template>
  <div class="app-layout">
    <div class="app-header">
      <Header :collectPointList.sync="collectPointList"
              :collectCount.sync="collectCount"
              :collectPointName.sync="collectPointName"
              :barcode.sync="barcode"
              :pkgBarcode.sync="pkgBarcode"
              :isLivePrint.sync="isLivePrint"
              v-on:updateDlgCollectPointVisible="updateDlgCollectPointVisible"></Header>
      <Navbar :collectCount.sync="collectCount"
              :barcode.sync="barcode"
              :isLivePrint.sync="isLivePrint"
              v-on:updateBarcode="updateBarcode"></Navbar>
    </div>
    <div class="app-main">
      <router-view :key="key"
                   :dlgCollectPointVisibleSync.sync="dlgCollectPointVisibleSync"
                   :collectPointIdSync.sync="collectPointIdSync"
                   :mergeCount.sync="mergeCount"
                   :barcodeFocus.sync="barcodeFocus"
                   v-on:updateIsLivePrint="updateIsLivePrint"
                   v-on:updateCollectCount="updateCollectCount"
                   v-on:updateBarcode="updateBarcode"
                   v-on:updatePkgBarcode="updatePkgBarcode"
                   v-on:showColPoint="showColPoint"></router-view>
    </div>
    <msgWindow  v-if='$store.state.closeMsgWindow'></msgWindow>
  </div>
</template>

<script>
  //import { header, navbar } from './compones' //为什么错误
  import Header from "./compones/header";
  import Navbar from "./compones/navbar";
  import msgWindow from "./compones/msgWindow";

  export default {
  name: "Layout",
  components: {
    Header,
    Navbar,
    msgWindow
  },
  data(){
    return {
      isLivePrint: "",
      dlgCollectPointVisibleSync: false,
      collectPointIdSync: null,
      collectPointList: [],
      collectPointName: '',
      mergeCount: 0,

      collectCount: 0,
      barcode: "",
      pkgBarcode: "",
      barcodeFocus: false,
      dlgColPoints: false
    }
  },
  computed: {
  key() {
  return this.$route.name !== undefined
  ? this.$route.name + +new Date()
  : this.$route + +new Date();
  },
  },
  mounted() {

  },
  methods: {
    updateDlgCollectPointVisible(e) {
      this.dlgCollectPointVisibleSync = e
    },
    updateCollectPointList(e) {
      this.collectPointList = e
    },
    updateCollectPointId(e) {
      this.collectPointIdSync = e
    },
    updateCollectPointName(e) {
      this.collectPointName = e
    },
      updateMergeCount(e) {
      this.mergeCount = e
    },

    updateIsLivePrint(e) {
      this.isLivePrint = e
    },
    updateCollectCount(e){
      this.collectCount = e
    },
    updateBarcode(e){
      this.barcode = e
    },
    updatePkgBarcode(e) {
      this.pkgBarcode = e
    },
    updateBarcodeFoucs(e) {
      this.barcodeFocus = false;
      this.$nextTick(() => {
        this.barcodeFocus = true;
      })
    },
    showColPoint(e) {
      this.dlgCollectPointVisibleSync = e
    }
  },
  };
</script>

<style lang="scss" scoped="">
.app-layout {
  width: 100%;
  height: 100%;
  position: relative;
}
.app-header {
  width: 100%;
  height: 60px;
  margin-bottom: 10px;
  /*box-shadow: 0 0 6px 1px rgba(51,120,228,.25);*/
  box-shadow: 0 0 10px 1px rgba(51,120,228,.15);
}
.app-main {
  width: 100%;
  height: calc(100% - 60px - 10px);
  /*padding: 10px;
  background: #cedce8;*/
}
.app-main > div {
  width: 100%;
  height: 100%;
  /*background: #fbfdff;
  border-radius: 4px;
  box-shadow: 0 0 16px 3px rgba(77, 147, 241, 0.68);
  box-shadow: 0 0 8px 1px rgba(77, 147, 241, 0.28);*/
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue